import apiCaller from '../../utils/apiCaller'
import localStorage from '../../utils/localStorage'
import types from '../types'

const state = {
    agreeToken: null,
    authToken: null,
    me: null,
    sidInfo: null
}

const mutations = {
    [types.sign.mutations.agreeToken] (state, { agreeToken }) {
        state.agreeToken = agreeToken
    },
    [types.sign.mutations.authToken] (state, { authToken }) {
        state.authToken = authToken
    },
    [types.sign.mutations.me] (state, { me }) {
        state.me = me
    },
    SET_SID_INFO( state, sidInfo) {
        state.sidInfo = sidInfo
    }
}

const actions = {
    async [types.sign.actions.agreeToken] ({ commit }) {
        const res = await apiCaller.sign.agreeToken()
        const agreeToken = res.data.token

        commit(types.sign.mutations.agreeToken, { agreeToken })

        return true
    },
    async [types.sign.actions.validToken] ({ state }) {
        const agreeToken = state.agreeToken
        const res = await apiCaller.sign.tokenCheck({ agreeToken })

        return res.data.valid
    },
    async [types.sign.actions.checkDuplicated] ({ }, { userId }) {
        const res = await apiCaller.sign.idCheck({ userId })
        return res.data.duplicated
    },
    async [types.sign.actions.up] ({ }, { userId, email, password, name }) {
        const agreeToken = state.agreeToken
        const res = await apiCaller.sign.up({ userId, email, password, name, agreeToken })

        return res.data.success
    },
    async [types.sign.actions.in] ({ commit }, { password, userId }) {
        try {
            const res = await apiCaller.sign.in(({ userId, password }))

            if (res.error === 404) {
                return res
            }

            const authToken = res.data.token
            localStorage.xAuthToken.set(authToken)

            commit(types.sign.mutations.authToken, { authToken })
        } catch (e) {
            return e
        }

        return true
    },
    async [types.sign.actions.me] ({ commit }, { authToken }) {
        try {
            const res = await apiCaller.sign.me({ authToken })

            if (res.error !== null) {
                return false
            }

            const me = res.data
            commit(types.sign.mutations.me, { me })

        } catch (e) {
            return e
        }
        return true
    },
    async [types.sign.actions.changeEmail] ({ commit }, { authToken, birthday, email, gender, name, userId }) {
        try {
            const res = await apiCaller.sign.changeEmail({ authToken, userId, gender, email, birthday, name })
            console.log(res)

            if (res.error !== null) {
                return false
            }

            const me = { userId, gender, email, birthday, name }
            commit(types.sign.mutations.me, { me })
        } catch (e) {
            return e
        }
        return true
    },
    async [types.sign.actions.changePassword] ({ }, { authToken, currentPassword, newPassword }) {
        try {
            const res = await apiCaller.sign.changePassword({ authToken, currentPassword, newPassword })
            console.log(res)
            if (res.error !== null) {
                return false
            }
        } catch (e) {
            return e
        }
        return true
    },
    [types.sign.actions.authToken] ({ commit }, { authToken }) {
        commit(types.sign.mutations.authToken, { authToken })
    },
    [types.sign.actions.logout] ({ commit }) {
        localStorage.clearAll()
        commit(types.sign.mutations.me, { me: null })
        commit(types.sign.mutations.authToken, { authToken: null })
    },
    async authBySid ({commit}, sid) {
        const res = await apiCaller.sign.authBySid(sid)
        if(Number(res.data.code) === 200) {
            commit('SET_SID_INFO', res.data.result)
            return res
        }
        return res
    }
}

const getters = {
    [types.sign.getters.agreeToken]: state => state.agreeToken || null,
    [types.sign.getters.authToken]: state => state.authToken || null,
    [types.sign.getters.me]: state => state.me || null,
    getSidInfo : (state) => state.sidInfo,
}

export default {
    state,
    mutations,
    actions,
    getters
}
